// extracted by mini-css-extract-plugin
export default {"formBox":"YoFormBox_formBox__LzkNH","formBoxClose":"YoFormBox_formBoxClose__ITq+T","formBoxHeader":"YoFormBox_formBoxHeader__5aMjy","formBoxBody":"YoFormBox_formBoxBody__UIomQ"};